import { request } from 'utils';

export const login = data =>
  request({
    method: 'POST',
    url: '/oauth/token',
    data,
  });
